<template>
  <div class="excel-upload">
    <span style="padding-bottom: 3px; display: inline-block">3. 上传数据源:</span>
    <el-upload
      class="upload-wrapper"
      action="false"
      ref="fileExcel"
      :on-remove="handleRemove"
      :limit="1"
      :accept="allowed"
      :on-exceed="handleExceed"
      :on-change="handleUpload"
      :auto-upload="false"
    >
      <el-button
        size="medium"
        type="primary"
        :loading="analysis"
        :disabled="ban || analysis || files_excel !== null"
        >{{ files_excel ? "已上传" : "点击上传" }}</el-button
      >
      <div slot="tip" class="el-upload__tip">只能上传excel(.xlxs)文件</div>
    </el-upload>
    <slot></slot>
  </div>
</template>

<script>
import { Message,Loading } from "element-ui";
import * as XLSX from "xlsx";
// import $pubsub from "../utils/pubsub.js";
import { readFile } from "../utils/excel.js";
import * as series from "../utils/chart";
import { whiteType } from "../utils/tools";
export default {
  name: "excel-upload",
  props: ["type"],
  data() {
    return {
      analysis: false,
      files_excel: null,
      allowed: ".xlsx,.doc",
    };
  },
  computed: {
    ban() {
      var status;
      if(!this.type) {
        status = true;
      } else if(whiteType.includes(this.type)) {
        status = true;
      } else {
        status = false;
      }
      return status
    }
  },
  methods: {
    checkFileType(name) {
      let flog = false;

      let fileName = name;

      let fileType = fileName.lastIndexOf(".");

      let extension = fileName.substring(fileType).toLowerCase();

      if (this.allowed.split(",").includes(extension)) {
        flog = true;
      } else {
        flog = false;
      }

      return flog;
    },

    async handleUpload(file) {
      this.analysis = true;

      const loadingInstance = Loading.service({
        customClass: 'my-loading-mask',
        lock: true,
        fullscreen: true,
        text: '上传中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      //检测文件类型
      if (!this.checkFileType(file.name)) {
        this.files_excel = null;
        this.$refs.fileExcel.clearFiles();
        Message({
          message: "抱歉，请选择.xlsx文件！",
          type: "error",
          duration: 5000,
        });
        this.analysis = false;

        this.$nextTick(() => {
          loadingInstance.close();
        })
        
        return false;
      }

      //选择excel文件后，并读取其内容（文件流）
      let dataBinary = await readFile(file.raw);

      if (dataBinary) {
        // 将整个文件以二进制形式读取
        let workBook = XLSX.read(dataBinary, { type: "binary", cellDates: true });

        // 工作表数量
        let workBookLen = workBook.SheetNames.length;

        // excel工作簿内容
        let excelBook = [];

        //读取每个sheets表
        for (let i = 0; i < workBookLen; i++) {
          let workSheet = workBook.Sheets[workBook.SheetNames[i]];
          excelBook.push({
            sheetName: workBook.SheetNames[i],
            data: XLSX.utils.sheet_to_json(workSheet, {
              defval: null, //单元格为空时的默认值
              raw: false, //使用w的值而不是v
              dateNF: "yyyy-MM-dd", //日期格式
            }),
          });
        }
        this.analysis = false;

        this.$nextTick(() => {
          loadingInstance.close();
        });

        this.files_excel = file;

        const option = series[this.type](excelBook); // echarts图option选项
        
        if (option) {

          this.$emit("handleData",{
            name: file.name.split(".")[0],
            data: option,
          });

          Message({
            message: "excel文件解析成功！",
            type: "success",
          });
        } else {
          this.files_excel = null;
          this.$refs.fileExcel.clearFiles();
        }
      }
    },

    handleRemove() {
      this.files_excel = null;
    },

    handleExceed() {
      Message({
        message: "抱歉，如果您已经上传过一个文件，则不能继续上传！",
        type: "error",
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.excel-upload {
  width: 50%;
  padding-left: 15px;
  display: flex;
  flex-direction: column;

  .upload-wrapper {
    display: flex;
    flex-direction: column;
    min-height: 120px;
    align-items: baseline;

    /deep/ .el-upload {
      padding: 10px 0;
    }
  }
}
</style>

<style>
.my-loading-mask {
  z-index: 10001!important;
}
</style>